<script>
	import Sidebar from './Sidebar/Sidebar.svelte';
	//import fs from 'fs';
	//const fsi = fs;
	let sidebar_show = false;

	const handleSubmit = event => {
		event.preventDefault();

		// do your verifications and checks
		if(!verified) return false    

		const REQUEST_PARAMETERS = {
			method: `POST`,
			headers: { 'Content-Type': `application/x-www-form-urlencoded` },
			body: encode({ ...data }), //your data here. Needs to have your form-name attribute set
		};

		fetch(`/`, REQUEST_PARAMETERS)
			.then(() => {
				console.log(`OK`);
				alert("Form was submitted!");
			})
			.catch(error => alert(error));
	};
	
	function sendEmail(data) {
			Email.send({
				Host: "smtp.gmail.com",
				Username: "proxy5821@gmail.com",
				Password: "adqlehumwfpzhtfx",
				To: 'eerkingtheawesome@gmail.com',
				From: "proxy5821@gmail.com",
				Subject: "Appointment Request Information",
				Body: data,
			})
			.then(function (message) {
				alert("Form was submitted!");
			});
		}

	const onSubmit = (e) => {
		const formData = new FormData(e.target);
  
		const data = {};
		for (let field of formData) {
			const [key, value] = field;
			data[key] = value;
		}
		sendEmail(data);
		
		console.log(data)
	}

	let saveFile = () => {
    	
        // Get the data from each element on the form.
    	const fname = document.getElementById('fname');
		const mname = document.getElementById('mname');
		const lname = document.getElementById("lname");
        const phone = document.getElementById('phone');
        const email = document.getElementById('email');
        const contact_pref = document.getElementById('contact');
        const msg = document.getElementById('notes');
        
        // This variable stores all the data.
        let data = 
            '\r Name: ' + fname.value + ' ' + mname.value + ' ' + lname.value + ' \r\n ' + 
            'Phone Number: ' +phone.value + ' \r\n ' + 
            'Email Address: ' + email.value + ' \r\n ' + 
            'Contact Preference: ' + contact_pref.value + ' \r\n ' + 
            'Message: ' + msg.value + ' \r\n ' +
			'Form submitted: ' + new Date().toLocaleString();
        
		/*const fs = require('fs');
		fs.writeFile('requests.txt', data, (err) => {
			if (err) throw err;
		})*/
		

        // Convert the text to BLOB.
        const textToBLOB = new Blob([data], { type: 'text/plain' });
        const sFileName = 'requests.txt';	   // The file to save the data.

        let newLink = document.createElement("a");
        newLink.download = sFileName;

        if (window.webkitURL != null) {
            newLink.href = window.webkitURL.createObjectURL(textToBLOB);
        }
        else {
            newLink.href = window.URL.createObjectURL(textToBLOB);
            newLink.style.display = "none";
            document.body.appendChild(newLink);
        }

        newLink.click();
		//alert("Form was submitted!");
    }
</script>

<main id="main">	
	<h1>Request an Appointment</h1>
	<hr>
	<br>
	<p class="subtitle">Fill out the form below to request an appointment. If you wish, you can let us know what times may work for you and what concerns you may have before we give you a call back.</p>
	<br>
	<div class="form">
	<form method="post" name=”Appointment_Request” data-netlify="true" data-netlify-honeypot="bot-field" onSubmit={handleSubmit}>
	<!--on:submit|preventDefault={saveFile} enctype="text/plain"-->
	<input type="hidden" name="form-name" value="Appointment_Request">
	<div class="row">
		<div class="column3">
				<label for="fname">First Name:</label><br>
				<input type="text" id="fname" name="fname" placeholder="" required><br>
				<label for="mname">Middle Name:</label><br>
				<input type="text" id="mname" name="mname" placeholder="">
				<label for="lname">Last Name:</label><br>
				<input type="text" id="lname" name="lname" placeholder="" required>
		</div>
		<div class="column3">
			
				<label for="phone">Phone Number:</label><br>
				<input type="tel" id="phone" name="phone" placeholder="123-456-7890" minlength="12" maxlength="12" required><br><br>
				<small>Format: 123-456-7890</small><br><br>
				<label for="email">Email Address:</label><br>
				<input type="email" id="email" name="email" placeholder="" required><br><br>
				
			
		</div>
		<div class="column3">
			<label for="contact">Please choose your preferred method of contact:</label><br>
			<select name="contact" id="contact">
				<option value="phone">Phone Call</option>
				<option value="email">Email</option>
			</select>
			<br><br>
				<label for="notes">Anything you would like to tell us before we contact you?</label><br>
				<textarea id="notes" name="notes" rows="4" cols="25" placeholder="Type here... (Optional)"></textarea><br><br>
				
			
		</div>
	</div>
	<input class="center" type="submit" name="submit" value="Submit">
	<input type="reset" name="reset" value="Clear Form">
	</form>
	</div><br>
	<p>After finishing this form, click the submit button above. Then click the patient forms button below to download and edit your patient forms to expedite your appointment.</p>
	<!--You should see a text document being downloaded to your device. Once fully downloaded, please email this text document as an attachment to <a href="mailto:shorelinefamilydentistry@gmail.com?subject=Appointment Request" >shorelinefamilydentistry@gmail.com</a> and-->
	<button on:click={() => sidebar_show = !sidebar_show}>☰ Patient Forms</button>
	<Sidebar bind:show={sidebar_show} />
	<br><br><br>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1000px;
		margin: 0 auto;
	}

	.form {
		
		text-align: left;
		padding: 2em 6em;
		background-color: aliceblue;
		border-radius: 15px;
	}

	.center{
		text-align: center;
	}

	.row {
  		display: flex;
	}

	.column3 {
		flex: 33%;
	}

	.subtitle{
		padding: 0px 100px;
	}

	button {
		background-color: rgb(116, 176, 211);
		border: none;
		color: white;
		padding: 12px 30px;
		cursor: pointer;
		font-size: 20px;
		transition: .1s;
	}

	button:hover {
		background-color: rgb(52, 80, 117);
	}

	
</style>